<template>
  <!--  서브페이지  -->
  <div id="sub_area">
    <!--비주얼 영역-->

    <div class="sub_visual">
      <div class="tit_area">
        <h2 class="tit">{{ title }}</h2>
      </div>
      <img :src="require('./../../assets/img/sub/sub05.png')" alt="BG" />
    </div>

    <div class="navigation_area">
      <div class="navigation">
        <router-link to="/" class="i_home">
          <span>HOME</span>
        </router-link>

        <div
          class="item"
          :class="{ on: mainMenuShow }"
          @mouseover="mainMenuShow = true"
          @mouseleave="mainMenuShow = false"
        >
          <a>{{ title }}</a>
          <div>
            <router-link
              active-class="on"
              tag="a"
              to="/Invest/finance"
              @click.native="mainMenuShow = false"
            >재무정보</router-link>
            <!-- 공고 삭제  장근주 대리 요청 2020-07-31 -->
            <router-link
              active-class="on"
              tag="a"
              to="/Invest/NotiList"
              @click.native="mainMenuShow = false"
            >공고</router-link>
          </div>
        </div>
      </div>
    </div>

    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data: () => ({
    mainMenuShow: false,
    message: "InvestMain.vue",
    title: "",
  }),
  methods: {
    titleChange(urlPath) {
      switch (urlPath) {
        case "/Invest/finance":
          {
            this.title = "재무정보";
          }
          break;
        case "/Invest/NotiList":
          {
            this.title = "공고";
          }
          break;
      }
    },
  },
  computed: {},
  watch: {
    $route(to, from) {
      this.titleChange(to.path);
    },
  },
  destroyed() {},
  created() {
    console.log("created - " + this.message);
    this.titleChange(this.$route.path);
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/sub05/InvestMain.vue